import { CPF, CNPJ } from 'cpf_cnpj'

import emitter from 'garden/src/js/utils/emitter'
import debounce from 'garden/src/js/utils/debounce'

import BaseComponent from 'scripts/components/base-component'

class FormType extends BaseComponent {
  static componentName = 'form-type'

  init () {
    this.element = this.$element[0]
    this.input = this.element.querySelector('[data-form-type-checker]')
    this.field = this.element.querySelector('[data-field]')
    this.cpfInput = this.element.querySelector('[data-document-number]')
    this.cnpjInput = this.element.querySelector('[data-company-number]')

    this.bindListeners()
  }

  bindListeners () {
    this.input.addEventListener(
      'keyup',
      debounce(this.onInputKeyUp, 300),
      false
    )
  }

  onInputKeyUp = ({ target }) => {
    const { value } = target

    if (CPF.isValid(value)) {
      this.setFieldValid()
      this.toggleForm('pf')
      this.cpfInput.value = value
      target.value = CPF.format(value)
      return
    }

    if (CNPJ.isValid(value)) {
      this.setFieldValid()
      this.toggleForm('pj')
      this.cnpjInput.value = value
      target.value = CNPJ.format(value)
      return
    }

    this.resetInputsHidden()
    this.setFieldInvalid()
    this.toggleForm()
  }

  resetInputsHidden () {
    this.cpfInput.value = ''
    this.cnpjInput.value = ''
  }

  setFieldInvalid () {
    this.field.classList.remove('valid')
    this.field.classList.add('invalid')
  }

  setFieldValid () {
    this.field.classList.remove('invalid')
    this.field.classList.add('valid')
  }

  resetAndHideForms (form) {
    form.classList.add('hidden')
    form.reset()

    Array.prototype.forEach.call(
      form.elements,
      (field) => emitter.emit('validation:pristine', field)
    )
  }

  toggleForm (type = null) {
    this.$element[0].querySelectorAll('[data-form-type]').forEach(this.resetAndHideForms)

    if (!type) {
      return
    }

    this.$element[0].querySelector(`[data-form-type="${type}"]`).classList.remove('hidden')
  }
}

export default ($el) => new FormType($el).init()

export { FormType as Component }
